import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle } from '@mui/material';
import { styled } from '@mui/material/styles';

type ConfirmDialogProps = {
  title: string;
  children: any;
  open: boolean;
  setOpen: Function;
  onConfirm: Function;
  cancelText: string;
  confirmText: string;
};

const BlurryDialog = styled(Dialog)<DialogProps>(({ theme }) => ({
  backdropFilter: 'blur(2px)',
}));

const ConfirmDialog = (props: ConfirmDialogProps) => {
  const { title, children, open, setOpen, onConfirm, confirmText, cancelText } = props;
  return (
    <BlurryDialog
      transitionDuration={0}
      hideBackdrop={true}
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="confirm-dialog"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle id="confirm-dialog" sx={{ fontWeight: 600 }}>
        {title}
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={() => setOpen(false)} color="inherit">
          {cancelText}
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            setOpen(false);
            onConfirm();
          }}
          color="error"
        >
          {confirmText}
        </Button>
      </DialogActions>
    </BlurryDialog>
  );
};
export default ConfirmDialog;
